<template>
  <div
    class="bg-background-neutral-primary relative flex h-screen flex-col px-4"
    style="padding-top: var(--status-bar-height)"
  >
    <FreeBackButton
      class="absolute left-4 z-10"
      style="top: calc(var(--status-bar-height, 0px) + 0.5rem + 9px)"
      @click="emit('onGoBack')"
    />

    <div
      class="flex flex-1 flex-col items-center justify-center gap-6 px-2 text-center"
    >
      <GreenInfoIcon width="56" height="56" />
      <h1 class="text-text-neutral-primary text-2xl font-bold leading-tight">
        {{ title }}
      </h1>
      <p
        class="text-text-neutral-tertiary whitespace-pre-line text-sm leading-relaxed"
      >
        {{ description }}
      </p>
    </div>

    <div class="pb-8">
      <FreeButton
        type="button"
        class="green-main-button z-10 w-full"
        @click="emit('onGoBack')"
      >
        {{ t('blockedSearchBanner.button') }}
      </FreeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeBackButton, FreeButton } from 'freedom-shared';

  import GreenInfoIcon from '@/assets/images/green-filled-info-icon.svg?component';

  import { useBlockedSearchBanner } from '../model';

  const props = defineProps<{
    depIata: string;
    arrIata: string;
    searchDate: string;
    returnDate?: string;
  }>();

  const emit = defineEmits<{
    onGoBack: [];
  }>();

  const { t, locale } = useI18n();

  const { config } = useBlockedSearchBanner({
    depIata: computed(() => props.depIata),
    arrIata: computed(() => props.arrIata),
    searchDate: computed(() => props.searchDate),
    returnDate: computed(() => props.returnDate),
  });

  const title = computed(() => {
    if (!config.value) return '';
    const lang = locale.value as 'ru' | 'kk' | 'en';
    return config.value[`title_${lang}`] || config.value.title_ru || '';
  });

  const description = computed(() => {
    if (!config.value) return '';
    const lang = locale.value as 'ru' | 'kk' | 'en';
    return (
      config.value[`description_${lang}`] || config.value.description_ru || ''
    );
  });
</script>
